<template>
	<div class="process-rate">
		<c-scroll>
			<div v-if="list" class="flex">
				<template v-for="(item, i) in list">
					<div v-if="i" class="line" :key="`line${i}`"></div>
					<div :ref="`item${i}`" :key="`item${i}`" class="item flex-column flex-center" @mouseenter="detailHandle(i)" @mouseleave="detailHandle()">
						<c-progress :rate="[item.fine_count, item.plan_count]" type="circle" size="40" line-size="3" font-size="12">
							<template #text="{rate}">
								<span v-if="rate == 100" style="font-size: 20px; color: var(--color-main);"><i class="c-icon-check"></i></span>
								<span v-else :style="{'color': rate > 100 ? '#f00' : ''}">{{rate.toFixed(0)}}%</span>
							</template>
						</c-progress>
						<p>{{item.process_name}}</p>
					</div>
				</template>
			</div>
		</c-scroll>

		<div v-show="detailData" ref="detail" class="process-rate-detail" :style="detailPosition" @mouseenter="detailHandle(-1)" @mouseleave="detailHandle()">
			<template v-if="detailData">
				<div class="head flex-between-center">
					<p>{{detailData.process_name}}</p>
					<c-state dict="orderStateDic" tag :value="detailData.state"></c-state>
				</div>
				<ul>
					<li class="flex-center-cross">
						<span>生产进度(%)：</span>
						<c-progress classs="flex-grow" :rate="[detailData.fine_count, detailData.plan_count]"></c-progress>
						<span>({{detailData.fine_count}}/{{detailData.plan_count}})</span>
					</li>
					<li class="flex-center-cross">
						<span>工序计划数：</span>
						<b>{{detailData.plan_count}}</b>
					</li>
					<li class="flex-center-cross">
						<span>已报工良品数：</span>
						<b style="color: var(--color-green);">{{detailData.fine_count}}</b>
					</li>
					<li class="flex-center-cross">
						<span>已报工不良品数：</span>
						<b style="color: var(--color-red);">{{detailData.defects_count}}</b>
					</li>
					<li class="flex-center-cross">
						<span>已审核良品数：</span>
						<b>{{detailData.fine_count_2}}</b>
					</li>
					<li class="flex-center-cross">
						<span>待审核良品数：</span>
						<b>{{detailData.fine_count_1}}</b>
					</li>
					<li class="flex-center-cross">
						<span>计划时间：</span>
						<b>{{detailData.plan_start_date}} - {{detailData.plan_end_date}}</b>
					</li>
					<li class="flex-center-cross">
						<span>最后报工时间：</span>
						<b>{{detailData.last_output_date || '-'}}</b>
					</li>
				</ul>
				<div v-if="auth('m_work')" class="button flex">
					<a class="flex-center flex-grow" @click="navigateTo(`/production/output?work_code=${detailData.work_code}&process_code=${detailData.process_code}`)">
						<i class="tf">&#xe76e;</i>
						<span>查看报工</span>
					</a>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {debounce, createStore, mapStore} from '@deanwu/vue-component-library'

	const STORE = createStore(Vue.extend({
		data() {
			return {
				queue: [],
				data: {}
			}
		},

		watch: {
			queue(val) {
				if (val.length) {
					this.getData();
				}
			}
		},

		methods: {
			get(id) {
				if (!this.queue.includes(id)) {
					this.queue.push(id);
				}
			},

			getData: debounce(function() {
				this.request({
					url: '/work/statisticList',
					data: {
						work_list: this.queue.map(id => {
							return {id};
						})
					},
					success: data => {
						for (let id in data) {
							this.$set(this.data, id, data[id]);
						}

						this.$nextTick(() => {
							this.data = {};
						});
					}
				});
				this.queue = [];
			}, 500)
		}
	}));

	export default {
		name: 'processRate',
		
		props: {
			id: [Number, String],
			detail: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				store: STORE,
				list: null,
				detailData: null,
				detailPosition: null
			}
		},

		computed: {
			...mapStore(['data'])
		},

		watch: {
			data(val) {
				if (val[this.id]) {
					this.list = val[this.id];
				}
			}
		},

		mounted() {
			this.store.get(this.id);
			document.body.appendChild(this.$refs.detail);
		},

		beforeDestroy() {
			document.body.removeChild(this.$refs.detail);
		},

		methods: {
			detailHandle(i) {
				if (!this.detail) return;
				if (i === undefined) {
					this._detailRequest && this._detailRequest.abort();
					this._timer = setTimeout(() => {
						this.detailData = null;
						this.detailPosition = null;
					}, 50);
				} else {
					clearTimeout(this._timer);
					if (i != -1) {
						this.detailData = null;
						this._detailRequest = this.request({
							url: '/task/detail',
							data: {
								id: this.list[i].id
							},
							success: data => {
								let rect = this.$refs[`item${i}`][0].getBoundingClientRect();
								this.detailData = data;
								this.$nextTick(() => {
									let target = this.$refs.detail.getBoundingClientRect();
									this.detailPosition = {
										left: rect.left + 'px',
										top: window.innerHeight - rect.top - rect.height > target.height
											? rect.top + rect.height + 'px'
											: rect.top - target.height - 5 + 'px'
									}
								});
							}
						})
					}
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.process-rate {
		position: relative;
		height: 62px;
		line-height: 16px;

		.line {
			min-width: 20px;
			height: 1px;
			margin: 20px 6px;
			background: #bbb;
		}

		.item {
			position: relative
			cursor: pointer;
			
			p {
				margin-top: 5px;
				font-size: 12px;

				^[-1]:hover ^[-1..-1] {
					color: var(--color-main);
				}
			}
		}

		&-detail {
			z-index: 99;
			position: fixed;
			left: 0;
			top: 0;
			width: 360px;
			border-radius: .2px;
			background: #fff;
			box-shadow: 0 0 10px 1px rgba(0,0,0,.15);

			.head {
				height: 52px;
				padding: 0 22px;

				p {
					font-size: 16px;
					font-weight: bold;
				}
			}

			ul {
				padding: 0 22px 14px;
				
				li {
					height: 30px;
					font-size: 13px;
					white-space: nowrap;
					color: #666;

					b {
						color: #000;
					}
				}
			}

			.button {
				a {
					gap: 5px;
					height: 36px;
					border-top: 1px solid #eee;
					font-size: 13px;
					color: #666;

					&:nth-child(n+2) {
						border-left: 1px solid #eee;
					}

					&:hover {
						color: var(--color-main);
					}
				}
			}
		}
	}
</style>
